// This file is automatically generated. Do not edit manually.

import { PartConfigurationView } from "src/api/generated/erp/db/types/tables/partConfigurationView";
import { ConfigurableObjectType } from "src/api/generated/erp/db/types/enums/configurableObjectType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationSearchApi {
	export async function searchPartConfiguration(args: {
		partConfigurationId: number;
	}): Promise<PartConfigurationSearchApi_PartConfigurationSearchResult | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configurationSearch/searchPartConfiguration",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response === "" ? null : (response as PartConfigurationSearchApi_PartConfigurationSearchResult | null);
	}
}

export interface PartConfigurationSearchApi_PartConfigurationSearchResult {
	connectedItems: Array<PartConfigurationSearchApi_ConnectedItem>;
	partConfiguration: PartConfigurationView;
}

export interface PartConfigurationSearchApi_ConnectedItem {
	description: string;
	objectType: ConfigurableObjectType;
}
